var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.author ? _c('div', {
    staticClass: "c--blog_author blog-post-author d-flex flex-row align-items-start align-items-sm-center"
  }, [_c('div', {
    class: _vm.imageCropperClass
  }, [_vm.author.image && _vm.author.image.url ? _c('img', {
    directives: [{
      name: "lazy-load",
      rawName: "v-lazy-load"
    }],
    staticClass: "blog-post-author-picture",
    attrs: {
      "data-src": _vm.author.image.url,
      "src": "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "blog-post-author-name-wrapper d-flex flex-column"
  }, [_vm.author.name ? _c('span', {
    staticClass: "blog-post-author-name"
  }, [_vm._v("\n      " + _vm._s(_vm.author.name) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.withBio && _vm.author.bio ? _c('p', {
    staticClass: "opa-70"
  }, [_vm._v("\n      " + _vm._s(_vm.author.bio) + "\n    ")]) : _vm._e()])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }